import { render } from "./yzm.vue?vue&type=template&id=e66cd1ee"
import script from "./yzm.vue?vue&type=script&lang=js"
export * from "./yzm.vue?vue&type=script&lang=js"

import "./yzm.vue?vue&type=style&index=0&id=e66cd1ee&lang=css"

import exportComponent from "C:\\Users\\shilina\\Desktop\\后台\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__